import React, { useState } from 'react';
import { IconDropdown as UIIconDropdown } from '@shopline/dashboard-ui';

const IconDropdown = ({ onChange, ...props }) => {
  const [isOpen, setIsOpen] = useState(false);

  const handleOptionChange = (optionValues) => {
    if (onChange) {
      onChange(optionValues);
    }
    handleButtonDropdownClose();
  };

  const handleButtonDropdownClose = () => {
    setIsOpen(false);
  };

  const onButtonDropdownClick = () => {
    setIsOpen(!isOpen);
  };
  return (
    <UIIconDropdown
      {...props}
      isOpen={isOpen}
      onSelectorClick={onButtonDropdownClick}
      onClose={handleButtonDropdownClose}
      onChange={handleOptionChange}
    />
  );
};

export default IconDropdown;
